module.exports = __webpack_public_path__ + "static/media/account-image-5.3726b8b8.jpg";